<template>
  <div class="dropdown-search-footer texture-light">
    <a :href="seeAllResultsPath" class="see-all-results">
      See All Results for "{{ queryString }}"
    </a>
  </div>
</template>

<script>
  export default {
    props: {
      queryString: { type: String, required: true }
    },
    computed: {
      seeAllResultsPath() {
        return `/search?q=${encodeURI(this.queryString)}`;
      }
    }
  };
</script>
